<!-- eslint-disable vue/valid-v-for -->
<template>
	<div>
		<b-row>
			<b-col cols="12">
				<h3>Other Payment</h3>
			</b-col>
		</b-row>
		<b-card no-body v-loading="is_loading">
			<div class="table-listings">
				<el-table ref="otherPaymentTable" style="width: 100%" size="small" show-summary
					:data="tableData" :header-cell-class-name="'text-13px'" :summary-method="getSummaries">
					<!-- CHECKBOX -->
					<!-- <el-table-column v-if=" _gHlp.checkAccess(allowAssignRoles)" type="selection" class-name="pb-3" width="55" fixed></el-table-column> -->
					<el-table-column type="index" width="50" class-name="text-center font-weight-bold"></el-table-column>

					<el-table-column label="Type" min-width="130" prop="loan_statue" sortable>
						<template slot-scope="scope">
							<b-form-select v-model="scope.row.type" :options="othPaymentOptions" :disabled="isViewOnly" size="sm" @change="setDescription(scope.$index,$event)"></b-form-select>
						</template>
					</el-table-column>

					<el-table-column label="Description" min-width="180" prop="description" sortable>
						<template slot-scope="scope">
							<b-form-input v-model="scope.row.description" type="text" :disabled="isViewOnly" size="sm"></b-form-input>
						</template>
					</el-table-column>

					<el-table-column label="Outstanding" min-width="150" prop="outstanding" sortable class-name="text-right">
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.outstanding" size="sm"
								:disabled="isViewOnly" :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column>

					<el-table-column label="Settlement" min-width="150" prop="settlement" sortable>
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.settlement" size="sm"
								:disabled="!scope.row.is_settled_bool || isViewOnly"
								:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column>

					<el-table-column label="Settle" min-width="100" prop="is_settled_bool" sortable>
						<template slot-scope="scope">
							<el-switch v-model="scope.row.is_settled_bool" active-color="#099A78"
								@change="handleChangeSettle(scope.row, scope.$index)" :disabled="isViewOnly"></el-switch>
						</template>
					</el-table-column>

					<el-table-column min-width="30" fixed="right" v-if="!isViewOnly">
						<template slot-scope="scope">
							<el-dropdown trigger="click" style="cursor: pointer">
								<p class="el-dropdown-link mb-0 top-line">
									<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
								</p>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="removeItem(scope.row.id, scope.$index)">
										<span class="text-danger">
											<!-- Trash-Can Icon -->
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
												<path fill="#DF3030"
													d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
											</svg>
											Delete
										</span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>

				</el-table>
			</div>
			<div class="text-right p-2" v-if="!isViewOnly">
				<el-button type="info" class="mx-1" size="mini" @click="generateItem" icon="el-icon-circle-plus-outline"> Generate Default Fee</el-button>
				<el-button type="primary" class="mx-1" size="mini" @click="addItem" icon="el-icon-circle-plus-outline"> Add</el-button>
				<el-button type="warning" class="mx-1" size="mini" @click="submitAndCalculate" icon="el-icon-circle-check">Save & Calculate</el-button>
			</div>
		</b-card>
	</div>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { Switch, Table, TableColumn, Button, Select, Option, Dropdown, DropdownItem, DropdownMenu } from 'element-ui';
import { swal } from '@/assets/js/httpImports.js';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import CurrencyInput from '@/components/CurrencyInput';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useCreditReportStore } from '@/stores/creditReportStore';
import { calculateFees } from '@/assets/js/calculator';

export default {
	props: ['is-view-only'],
	components: {
		CurrencyInput,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Button.name]: Button,
		[Switch.name]: Switch,
		[Select.name]: Select,
		[Option.name]: Option,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
	},
	data() {
		return {
			is_loading_rows: [],
			oldTableData: [],
			tableData: [],
			tableSummary: {},
			tableColumnSkipSummary: [0, 1, 2, 5],
			formData:{
				othPaymentItemsList:[],
				other_payment_outstanding:0,
				other_payment_settlement:0
			},
			othPaymentOptions: [],
			deletedItemIds:[],
		}
	},
	created() {
		this.getOthPaymentOptions();
		this.initComponent();
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCustomerStore, ['activeLoanECOtherPayment', 'activeLoanEC', 'activeFormLoanEc']),
		is_loading(){
			return _gHlp.isLoading('fetch_oth_payment_items') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.formData = { ...this.formData, ...newVal }
				}
			},
			immediate: true
		},
		activeLoanECOtherPayment: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.initComponent();
				}
			},
			immediate: true
		},
		tableSummary: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.callbackTableSummary(newVal);
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCommonStore, ['getDroplist']),
		...mapActions(useCustomerStore, ['getOtherPaymentList', 'createOrUpdateOtherPayment', 'deleteOtherPayment', 'setFormLoanEc']),
		clearComponent(){
			this.is_loading_rows= []
			this.oldTableData= []
			this.tableData= []
			this.tableSummary= {}
			this.formData = {
				othPaymentItemsList:[],
				other_payment_outstanding:0,
				other_payment_settlement:0
			},
			this.deletedItemIds= []
		},
		initComponent() {
			_gHlp.setLoading('fetch_oth_payment_items')
			this.fetcAllRelations(this.activeLoanECOtherPayment)
		},
		checkDuplicateData(data){
			const resultMap = new Map();
			const overwrittenIds = [];

			for (const item of data) {
				const key = `${item.type}-${item.description}`;
				const existing = resultMap.get(key);
				
				if (!existing) {
					// First entry for this combination
					resultMap.set(key, item);
				} else {
					// Handle duplicate
					if (item.proposal_pfee_id && !existing.proposal_pfee_id) {
						// New one has proposal_pfee_id → overwrite
						overwrittenIds.push(existing.id);
						resultMap.set(key, item);
					} else if (!item.proposal_pfee_id && existing.proposal_pfee_id) {
						// Keep existing (has proposal_pfee_id)
						overwrittenIds.push(item.id);
					} else {
						// Both have or both don't → keep latest (overwrite)
						overwrittenIds.push(existing.id);
						resultMap.set(key, item);
					}
				}
			}
			this.tableData = [...resultMap.values()];
			this.deletedItemIds = overwrittenIds;
		},
		fetcAllRelations(resp){
			this.tableData = [];
			if (!_gHlp.isEmpty(resp) && !_gHlp.isEmpty(resp.data)) {
				let tableData = resp.data.map(itm => ({
					...itm,
					is_settled_bool: (itm.is_settled == 1)
				}));
				this.tableData = [
					...new Map(tableData.map(item => [item.type, item])).values()
				];
			}
			this.setOldData()
			_gHlp.removeLoading('fetch_oth_payment_items')
		},
		setOldData(){
			this.oldTableData = cloneDeep(this.tableData)
		},
		setDescription(idx,event){
			const type = this.othPaymentOptions.find(itm => itm.value === event);
			this.tableData[idx].description = _gHlp.getValue(type,'description');
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			const cbData = [];

			columns.forEach((column, index) => {
				if (index === 2) {
					sums[index] = 'Total';
					return;
				}
				if (this.tableColumnSkipSummary.includes(index)) {
					return;
				}

				const values = data.map(item => {
					return Number(item[column.property])
				});
				if (!values.every(value => isNaN(value))) {
					const total = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);

					sums[index] = 'RM ' + total.toLocaleString('en-MY', { minimumFractionDigits: 2 });
					cbData[column.property] = total
				} else {
					sums[index] = '';
				}
			});

			//callback
			this.tableSummary = cbData;
			return sums;
		},
		callbackTableSummary(data, save=false) {
			this.formData.othPaymentItemsList = this.tableData.filter((item) => { return item.is_settled == 1 });
			this.formData.other_payment_outstanding = !_gHlp.isEmpty(data) ? parseFloat(data.outstanding) : 0;
			this.formData.other_payment_settlement = !_gHlp.isEmpty(data) ? parseFloat(data.settlement) : 0;
			this.setFormLoanEc(this.formData)
			this.$emit('change',save);
		},
		addItem() {
			this.tableData.push({
				id: null,
				type: null,
				description: null,
				outstanding: 0,
				settlement: 0,
				is_settled: 0,
				is_settled_bool: false
			})
		},
		getOthPaymentOptions() {
			this.getDroplist('lec_other_payment').then((res) => {
				this.othPaymentOptions = res;
			});
		},
		handleChangeSettle(item, index) {
			if (item.is_settled_bool) {
				item.settlement = item.outstanding;
				item.is_settled = 1;
			} else {
				item.is_settled = 0;
				item.settlement = 0;
			}
			this.tableData[index] = item;
		},
		removeItem(id, index) {
			// Check if the index is within the array bounds
			if (index >= 0 && index < this.tableData.length) {
				// Use splice to remove the item at the specified index
				this.tableData.splice(index, 1);
				if (!_gHlp.isEmpty(id)) {
					this.deletedItemIds.push(id);
				}
			}
		},
		getParams(item) {
			if(_gHlp.isEmpty(item)) return {}

			return {
				id: item.id,
				type: item.type,
				description: item.description,
				outstanding: parseFloat(item.outstanding),
				settlement: parseFloat(item.settlement),
				is_settled: item.is_settled_bool ? 1 : 0
			}
		},
		submitAndCalculate(){
			let updateItems = [];
			//DELETD ITEMS
			if(!_gHlp.isEmpty(this.deletedItemIds)){
				for(let i = 0; i < this.deletedItemIds.length; i++){
					let itmId = this.deletedItemIds[i];
					updateItems.push(this.deleteOtherPayment(itmId))
				}
			}

			//UPDATE ITEMS
			for (let idx = 0; idx < this.tableData.length; idx++) {
				const newData = this.getParams(this.tableData[idx])	
				const oldData = this.getParams(this.oldTableData.find(itm => itm.id === newData.id));
				if(_gHlp.isEmpty(oldData) || !isEqual(newData, oldData)) {
					updateItems.push(this.createOrUpdateOtherPayment(newData));
				}
			}
			
			if(!_gHlp.isEmpty(updateItems)){
				_gHlp.setLoading('fetch_oth_payment_items')
				Promise.all(updateItems)
				.then(res  => {
					this.callbackTableSummary(this.tableSummary,true)
					this.getOtherPaymentList().then(resp => {
						this.fetcAllRelations(resp)
						this.deletedItemIds = [];
					})
					this.setOldData()
					_gHlp.removeLoading('fetch_oth_payment_items')
				})
				.catch(e => {
					_gHlp.removeLoading('fetch_oth_payment_items')
				})
			}
		},
		generateItem(){
			const loanType = _gHlp.getValue(this.activeFormLoanEc, 'selectedLoanType', {});
			if(_gHlp.isEmpty(loanType)){
				_gNotif.notifyError('Please select a loan type');
				return false;
			}
			swal.fire({
				title: 'Generate Confirmation',
				text: "This will override your existing other payment fees data",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Proceed',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
						

					let tenure_year = (this.formData.loan_tenure_period == 'Years') ? this.formData.loan_tenure : (this.formData.loan_tenure / 12);
					let feesData = {
						stamp_duty: parseFloat(_gHlp.getValue(this.formData, 'stamp_duty', 0)),
						vet_fac_amt: parseFloat(_gHlp.getValue(this.formData, 'vet_fac_amt', 0)),
						stakeholder_sum: parseFloat(_gHlp.getValue(this.formData, 'stakeholder_sum', 0)),
						legal_fees: parseFloat(_gHlp.getValue(this.formData, 'legal_fees', 0)),
					}
					const result = calculateFees(feesData, tenure_year,this.formData.debt_consolidation_amount,loanType,this.formData.interest_rate,this.formData.loan_amount, true);

					const curStampDuty = this.tableData.find(itm => itm.type == 'Stamp Duty');
					const curLegalFee = this.tableData.find(itm => itm.type.includes("Legal Fees"));
					const curStakeHolder = this.tableData.find(itm => itm.type == 'Stakeholder Sum');
					const curVFService = this.tableData.find(itm => itm.type == 'Vetting and Facilitation Services');

					const newItems = [
						//Stamp Duty
						{
							id: _gHlp.getValue(curStampDuty,'id',null),
							type: 'Stamp Duty',
							description: _gHlp.getValue(curStampDuty,'description',null),
							outstanding: parseFloat(_gHlp.getValue(result, 'stamp_duty', 0)),
							settlement: parseFloat(_gHlp.getValue(result, 'stamp_duty', 0)),
							is_settled: 1,
							is_settled_bool: true
						},
						{
							id: _gHlp.getValue(curLegalFee,'id',null),
							type: 'Legal Fees & SST',
							description: _gHlp.getValue(curLegalFee,'description',null),
							outstanding: parseFloat(_gHlp.getValue(result, 'legal_fees', 0)),
							settlement: parseFloat(_gHlp.getValue(result, 'legal_fees', 0)),
							is_settled: 1,
							is_settled_bool: true
						},
						{
							id: _gHlp.getValue(curStakeHolder,'id',null),
							type: 'Stakeholder Sum',
							description: _gHlp.getValue(curStakeHolder,'description',null),
							outstanding: parseFloat(_gHlp.getValue(result, 'stakeholder_sum', 0)),
							settlement: parseFloat(_gHlp.getValue(result, 'stakeholder_sum', 0)),
							is_settled: 1,
							is_settled_bool: true
						},
						{
							id: _gHlp.getValue(curVFService,'id',null),
							type: 'Vetting and Facilitation Services',
							description: _gHlp.getValue(curVFService,'description',null),
							outstanding: parseFloat(_gHlp.getValue(result, 'vf_service_fees', 0)),
							settlement: parseFloat(_gHlp.getValue(result, 'vf_service_fees', 0)),
							is_settled: 1,
							is_settled_bool: true
						},
					]
					
					this.tableData = _gHlp.patchData(this.tableData, newItems, 'type');
					this.submitAndCalculate();
					_gNotif.notifySuccess("Default Fee & Charge Generated",1000,'success');
				}
			});		
		}
	}
}
</script>